import { feedbackcard } from '@yes.technology/react-toolkit'
import { FlatActivityModel, Translate } from 'types/shared'

type StepErrorMessage = {
  title: string
  description?: string
}

export const showError = ({ error }: { error: StepErrorMessage }) => {
  const { title, description } = error

  if (!title) return false

  feedbackcard(title, {
    type: 'error',
    message: description || ''
  })

  return true
}

type ShowStepErrorMessagesProps = {
  stepName: string
  invalidActivities: {
    helperText?: {
      des: string
      complement?: string
    }
    activityModel: FlatActivityModel
    parentPath?: string[]
  }[]
  t: Translate
}

export const getStepErrorMessages = ({
  stepName,
  invalidActivities,
  t
}: ShowStepErrorMessagesProps): StepErrorMessage[] => {
  if (!invalidActivities.length) {
    return []
  }

  return [
    ...invalidActivities.flatMap((invalidActivity) => {
      if (invalidActivity.activityModel.content_type === 'agreement_term') {
        return {
          title: invalidActivity.activityModel.error_text?.des || stepName
        }
      }

      const fieldLabel = invalidActivity.activityModel.display_text?.des
      const hasFieldLabel = !!fieldLabel?.trim()

      if (!hasFieldLabel) {
        return {
          title: t('step.validation.message-generic-is-required-field-title'),
          description: t(
            'step.validation.message-generic-is-required-field-description'
          )
        }
      }

      if (invalidActivity.parentPath?.length) {
        const groupIndex = parseInt(
          invalidActivity.parentPath.at(-1)!.toString()
        )

        return {
          title: t(
            invalidActivity.helperText
              ? `step.group-validation-messages.${invalidActivity.helperText.des}`
              : 'step.group-validation-messages.is-required-field',
            {
              field: fieldLabel,
              groupNumber: String(groupIndex + 1)
            }
          ),
          description: invalidActivity.helperText?.complement
            ? t(
                `step.group-validation-messages.${invalidActivity.helperText.complement}`,
                {
                  field: fieldLabel,
                  groupNumber: String(groupIndex + 1)
                }
              )
            : undefined
        }
      }

      return {
        title: t(
          invalidActivity.helperText
            ? `step.validation-messages.${invalidActivity.helperText.des}`
            : 'step.validation-messages.is-required-field',
          {
            field: fieldLabel
          }
        ),
        description: invalidActivity.helperText?.complement
          ? t(
              `step.validation-messages.${invalidActivity.helperText.complement}`,
              { field: fieldLabel }
            )
          : undefined
      }
    }),
    ...(invalidActivities.length > 1
      ? [{ title: t('step.validation.message-all-required-fields') }]
      : [])
  ]
}
